
export const sendAnalyticsData = async ({ session_id, hash, variant, event_type, referrer, product_id }) => {

  let analyticsData = {
    created_at: (new Date()).toISOString(),
    event_type: event_type,
    session_id: session_id,
    asset_hash: hash,
    variant_id: variant,
    product_id: product_id,
    referrer: referrer,
    device_type: window.navigator.userAgent,
  };

  let url = "https://eo9muwoz3m.execute-api.us-east-1.amazonaws.com/dev/event";

  let options = {
    method: "POST",
    body: JSON.stringify(analyticsData),
    headers: {
      'Content-Type': 'application/json'
    }
  };

  try {
    const response = await fetch(url, options);
    if(!response.ok) { throw new Error(`Fetch Call Cannot Be Made`)};
    const data = await response.json();
    return data;
  } catch (e) {
    console.log('error', e);
  };
};
